






























































































































































import {
  Component, Mixins,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import UserModule from '@/store/modules/User';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component({
  components: {},
})
export default class User extends Mixins(
  ToolMixin, ErrorHandleMixin,
) {
  UserInstance = getModule(UserModule, this.$store);

  searchUsername = {
    username: '',
  };

  userData: any = {};

  modeKey = '';

  amount = 0;

  isAgent = false;

  async findUser() {
    this.GeneralInstance.toggleLoading(true);
    const { data, status } = await this.UserInstance.GetUser(this.searchUsername);
    if (status.code) this.checkError(status);
    this.GeneralInstance.toggleLoading(false);
    this.userData = data;
    if (this.userData.role === 'AGENT') this.isAgent = true;
    else this.isAgent = false;
  }

  async edit() {
    this.GeneralInstance.toggleLoading(true);
    const { status } = await this.UserInstance.EditUser({
      username: this.userData.username, amount: this.amount, key: this.modeKey,
    });
    this.checkError(status);
    this.findUser();
    this.modeKey = '';
    this.amount = 0;
  }
}
